import React from "react";
import { Field } from "formik";
import RequiredIcon from "./RequiredIcon";
import { stringToBoolean } from "../../../helper/utility";

const TextArea = (props) => {
  let className = props.className;
  if (!className) {
    className = "form-control";
  }

  return (
    <div className="form-group">
      <div className="mb-2">
        <label className="form-label">{props.label} </label>
        {stringToBoolean(props?.notrequired) ? "" : <RequiredIcon />}
        <Field
          as="textarea"
          {...props}
          className={className}
          style={{ height: "100px" }}
        />
        {(props.errors || props.touched) && (
          <p className="error-msg">{props.errors}</p>
        )}
      </div>
    </div>
  );
};

export default TextArea;
